import { formatShortDate } from '../../utils/datetime';

/**
 * How long ago, as short as a list row allows: "Hozirgina", "5 daq", "3 soat", "2 kun", then the
 * date ("5-okt", with the year once it is not this year). One helper for the chat list and the
 * ticket list, so the same moment reads the same in both. `t` is the page's translator; the exact
 * date and time belong in the `title` of whatever shows this (formatDateTime).
 */
export function formatWhenShort(value, t) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const minutes = Math.floor((Date.now() - date.getTime()) / 60000);
  if (minutes < 1) return t('messaging.justNow');
  if (minutes < 60) return t('messaging.minutesShort', { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('messaging.hoursShort', { count: hours });
  const days = Math.floor(hours / 24);
  if (days < 7) return t('messaging.daysShort', { count: days });
  return formatShortDate(date, { year: 'auto' });
}

/** A phone or tablet keyboard has no Shift+Enter: there Enter is a new line and the send button sends. */
export function hasTouchKeyboard() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches;
}
